import { createReducer } from '@lib/plugin-redux-core';
import { exploreHandlers } from './explore.handler';
import { ExplorePageInitialState } from './explore.states';

const initialState: ExplorePageInitialState = {
  error: null,
};

export const exploreReducer = createReducer(initialState, [...exploreHandlers]);
